import {Component, EventEmitter, inject, input, Output} from '@angular/core';
import {OrderHistoryService, OrderLineItem} from '../../core/services/order-history.service';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {PricePipe} from '../../core/pipes/price.pipe';
import {MatPaginator, MatPaginatorIntl, PageEvent} from '@angular/material/paginator';
import {CustomPaginatorIntl} from '../../core/custom-material/mat-paginator';

@Component({
  selector: 'app-order-line-item-table',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatCellDef,
    MatHeaderCellDef,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    DatePipe,
    PricePipe,
    CurrencyPipe,
    MatPaginator,
  ],
  providers: [{provide: MatPaginatorIntl, useClass: CustomPaginatorIntl}],
  templateUrl: './order-line-item-table.component.html',
  styleUrl: './order-line-item-table.component.scss'
})
export class OrderLineItemTableComponent {

  orderHistoryService = inject(OrderHistoryService);

  displayedColumns = input<string[]>(['date', 'productName', 'qty', 'unitPrice', 'totalPrice']);
  lineItems = input<OrderLineItem[] | undefined>([]);
  totalItems = input<number>(0);
  pageIndex = input<number>(0);

  showPagination = input<boolean>(true);
  hideStoreName = input<boolean>(false);

  @Output() pageChange = new EventEmitter<number>();

  getHumanStoreName(storeName?: string) {
    if (!storeName) {
      return 'Ukendt';
    }
    return this.orderHistoryService.getHumanStoreName(storeName);
  }

  changePage(pageEvent: PageEvent) {
    this.pageChange.emit(pageEvent.pageIndex);
  }

}
